import React from "react";
import WrioHeroSection from "./WrioHeroSection";
import WrioApproach from "./WrioApproach";
import InfiniteLogoScroll from "./Trusted";

const HomePage = () => {
  return (
    <div>
      <WrioHeroSection />
      <WrioApproach />
      <InfiniteLogoScroll />
    </div>
  );
};

export default HomePage;
